<template>
  <div class="serverError">
    <img class="server-img"
      :src="require('@/assets/preview/dataFailure.png')"
      alt="系统服务维护中 "
    />
    <p class="server-title">网络异常,  导致数据加载失败</p>
    <p class="server-info">文档最新内容会在网络恢复后同步</p>
    <el-button type="primary" class="mt-1 common-primary" @click="reload">重新加载</el-button>
  </div>
</template>

<script>
import utils from '@/utils/utils'
export default {
  name: 'ServerError',
  methods: {
    reload () {
      utils.toEditPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.serverError {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  .server-img {
    width: 340px;
    height: auto;
  }
  .server-title {
    color: #262626;
    font-weight: 400;
    font-size: 18px;
    margin-top: 10px;
  }
  .server-info {
    color: #7d8791;
    margin-top: 10px;
  }
  .mt-1 {
    width: 140px;
    height: 40px;
    margin-top: 20px;
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/error/serverError.vue